/**
 * Created by slava on 10/8/18
 */

cleverapps.styles.GameScene = {
    exclamation: {
        x: { align: "center", dx: 0 },
        y: { align: "center", dy: 0 }
    },

    actor: undefined,
    startAnimation: undefined,

    sound: {
        delay: 1
    },

    debugLevelNo: {
        x: { align: "right", dx: -100 },
        y: { align: "bottom", dy: 100 }
    }
};

cleverapps.styles.GameScene.STYLING = {
    bonus: {
        backgroundId: "background_bonus",
        bundle: "game_background_vertical",
        music: bundles.game.urls.background_music_game
    },

    hard: {
        backgroundId: "background_hard",
        bundle: "game_background_vertical",
        music: bundles.game.urls.background_music_hard
    },

    regular: [
        {
            bundle: "game_background_vertical",
            music: bundles.game.urls.background_music_game
        }
    ]
};

if (["differences"].indexOf(cleverapps.config.name) !== -1) {
    cleverapps.styles.GameScene.STYLING.hard.patternId = "background_hard";
    cleverapps.styles.GameScene.STYLING.regular[0].patternId = "background";
}

(function () {
    const example = cleverapps.styles.GameScene.STYLING.regular[0];

    for (let i = 2; ; i++) {
        if (!bundles.game_background_vertical) {
            if (!bundles.game_background_horizontal || !bundles.game_background_horizontal.urls[`background_${i}`]) {
                break;
            }
        } else if (!bundles.game_background_vertical.urls[`background_${i}`]) {
            break;
        }

        cleverapps.styles.GameScene.STYLING.regular.push({
            backgroundId: `background_${i}`,
            bundle: example.bundle,
            music: example.music,
            patternId: example.patternId
        });
    }
}());
